import React from "react";
import CommonSendComponent from "../../components/CommonSendComponent";
import { SEND_CONFIGS } from "../../config/sendConfigs";
import Menu from "../Menu";

const SendAudioPackage = () => {
  return (
    <>
      <Menu />
      <CommonSendComponent config={SEND_CONFIGS.audioPackage} />
    </>
  );
};

export default SendAudioPackage;
